import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StandardFile } from 'src/app/classes/shared/file/file';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { storage_url } from 'src/app/controls/functions/shared-functions';
import * as fs from 'file-saver';


@Injectable()
export class FilesService {
  api_url = environment.ATTACHMENT_URL;
  url = environment.SERVER_URL;
  py_url = environment.VIEWER_URL;
  constructor(
    private http: HttpClient,
    private notification_srv: NotificationService
  ) { }


  convertFilesToBase64(files) {
    return new Observable((obs) => {
      if (files && files.length) {
        let converted = [];
        for (let i = 0; i < files.length; i++) {
          if (files[i]) {
            let reader = new FileReader();

            reader.onload = () => {
              let file = new StandardFile();
              let extension;
              try {
                let length = files[i].name.split('.').length;
                extension = files[i].name.split('.') ? files[i].name.split('.')[length - 1] : '';
                if (extension) {
                  extension = extension.toLowerCase();
                }
              }
              catch (err) {
                extension = '';
              }

              file.setFileDetails(files[i].name, files[i].type, reader.result, extension, 1, 0, files[i].size, 1, null, files[i].lastModified)
              converted.push(file);
              if (files.length == converted.length) {
                obs.next(converted);
              }
            }
            reader.readAsDataURL(files[i]);
          }
        };
      }
      else {
        obs.next([]);
      }
    })
  }

  generateOnbAppointmentLetter(obj) {
    return this.http.post(this.py_url + 'icrweb/home/save_generate_onboarding_appointment_letter', obj);
  }

  // convertFilesToBase64(files) {
  //   return new Observable((obs) => {
  //     if (files && files.length) {
  //       let converted = [];
  //       for (let i = 0; i < files.length; i++) {
  //         if (files[i]) {
  //           let reader = new FileReader();

  //           reader.onload = () => {
  //             let file = new ICRFile();
  //             file.setFileDetails(files[i].name, files[i].type, files[i].size, files[i], reader.result, null)
  //             converted.push(file);
  //             if (files.length == converted.length) {
  //               obs.next(converted);
  //             }
  //           }
  //           reader.readAsDataURL(files[i]);
  //         }
  //       };
  //     }
  //     else {
  //       obs.next([]);
  //     }
  //   })
  // }

  convertBase64ToFiles(files) {
    return new Observable((obs) => {
      if (files && files.length) {
        let converted = [];
        for (let i = 0; i < files.length; i++) {
          if (files[i]) {
            files[i].file = this.dataURLtoFile(files[i].base64, files[i].fileName);
          }
        };
        obs.next(files);
      }
      else {
        obs.next([]);
      }
    })
  }

  dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  saveAttachments(files, multiple) {
    if (multiple && files && files.length) {
      return new Observable(obs => {
        this.recursiveSave(files, 0, [], obs);
      })
    }
    else if (files && files.length == undefined) {
      return this.saveAttachment(files)
    }
    else {
      return new Observable(obs => {
        obs.next(null);
      });
    }
  }

  recursiveSave(files, index, response, observable) {
    if (files[index] && files[index].content && !files[index].cdnPath) {
      this.saveAttachment(files[index]).subscribe(res => {
        this.notification_srv.success(('Uploaded attachments ' + (index + 1) + '/' + files.length), 'Close', 5000);
        if (!response) {
          response = [];
        }
        if (res && res['data']) {
          response.push(res['data']);
        }
        if (index < files.length - 1) {
          return this.recursiveSave(files, ++index, response, observable);
        }
        else {
          observable.next(response);
        }
      }, err => {

      })
    }
    else {
      response.push(files[index]);
      if (index < files.length - 1) {
        return this.recursiveSave(files, ++index, response, observable);
      }
      else {
        observable.next(response);
      }
    }
  }

  getBase64String(req) {
    return this.http.post(this.py_url + 'icrweb/home/docviewer', req)
  }

  saveAttachment(file) {
    let f = this.makeFormDataFile(file);
    let form_data = new FormData();
    form_data.append('attachment', f, f.name)
    return this.http.post(this.url + 'service_attachment', form_data, {
      headers: { header_type: '2' }
    })
    // return this.http.post("", fd)
  }

  uploadAttachment(form_data,header_type="2") {
    return this.http.post(this.url + 'service_attachment', form_data, {
      headers: { header_type: header_type }
    });
  }

  getDocxBase64(filepath, header_type?) {
    // https://www.icanrefer.com/api_v1/icrweb/home/viewDocNew?lngId=1
    return this.http.post(this.py_url + 'icrweb/home/viewDocNew_v1', {
      cdnPath: filepath
    },
      {
        headers: {
          header_type: header_type ? header_type.toString() : '1'
        }
      })
  }

  makeFormDataFile(file) {
    try {
      if (file) {
        let base64 = (file.content);
        let file_title = (file.file_title);
        let mime_type = (file.mime_type);
        function dataURLtoFile(dataurl, filename) {

          var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }

          return new File([u8arr], filename, { type: mime });
        }
        let formatted_file = dataURLtoFile(base64, file_title);
        return formatted_file;
      }
    }
    catch (err) {


    }

  }

  resumeParser(request) {
    return this.http.post(this.py_url + 'icrweb/home/resumeParser', request);
  }

  getURL(cdnPath, header_type?) {
    return this.http.get(this.py_url + 'icrweb/home/get_object_url', {
      headers: { header_type: header_type || '2' },
      params: {
        cdnPath: cdnPath
      }
    });
  }

  docxFileToPdf(form_data) {
    return this.http.post(this.py_url + 'icrweb/home/viewPdfFromFile', form_data);
  }

  saveFileFromURL(url, fileName) {
    this.getURL(url).subscribe(res => {
      if (res && res['data']) {
        this.saveFromURL(res['data'].url, fileName).subscribe(file => {
        })
      }

    }, err => {
      let link = document.createElement("a");
      link.download = fileName;
      // console.log(link.download)
      link.setAttribute('download', fileName);
      link.href = storage_url + url;
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
  }

  saveFromURL(cv: string, name) {
    // this.http.get(cv, { responseType: "blob" }).subscribe(blob => {
    //   const reader = new FileReader();
    //   const binaryString = reader.readAsDataURL(blob);
    //   reader.onload = (event: any) => {
    //     //Here you can do whatever you want with the base64 String
    //     console.log("File in Base64: ", event.target.result);
    //   };

    //   reader.onerror = (event: any) => {
    //     console.log("File could not be read: " + event.target.error.code);
    //   };
    // });

    let obs = new BehaviorSubject<any>(null);
    if (cv && cv != '') {

      let base64;

      var xhr = new XMLHttpRequest();
      xhr.open('GET', cv + '', true);
      xhr.responseType = 'blob';
      xhr.onload = function (e) {

        if (this.status == 200) {

          // Note: .response instead of .responseText

          console.log(this.response);



          var blob = new Blob([this.response], { type: this.response.type });
          fs.saveAs(blob, name);
        }

      };



      xhr.send();

    }
    return obs.asObservable();
  }

  documentDeclaration(obj) {
    return this.http.post(this.py_url + 'icrweb/home/save_and_generate_offer_onb_agreed_document', obj)
  }


}
